<template>
<div>
    <div v-if="loading" class="text-center">
        <v-progress-circular color="primary" indeterminate rounded height="6"></v-progress-circular>
    </div>
    <div class="d-flex" v-if="items.length>0">
        <div class="mr-2">Simple Factura</div>
        <v-chip
            small
            outlined
            class="mr-1 primary"
            v-for="item in items"
            :key="item.id"
            @click="openPdf(item)"
        >
            {{ tipoLabel(item.tipo) }} {{ item.folio }}
        </v-chip>
    </div>
</div>
</template>
<script>
import { fetchDocuments, downloadDocumentPdf } from '@/api/simplefactura'
import notifications from '@/utils/notifications'

export default {
    name: 'SimpleFacturaDocumentsChips',
    props: ['work_order_id', 'documents'],
    data() {
        return {
            loading: false,
            items: [],
        }
    },
    computed: {
        enabled() {
            return !!this.$store.getters.getCompany?.simplefactura_integration_enabled
        },
    },
    methods: {
        tipoLabel(tipo) {
            if (tipo == 33) return 'F'
            if (tipo == 52) return 'G'
            if (tipo == 61) return 'NC'
            return tipo
        },
        async openPdf(item) {
            try {
                await downloadDocumentPdf(item.id)
            } catch (err) {
                notifications.showError(err)
            }
        },
        async fetch() {
            if (Array.isArray(this.documents)) {
                this.items = this.documents
                return
            }
            this.items = []
            if (this.work_order_id && this.enabled) {
                this.loading = true
                const query = `page=1&page_size=100&ordering=-created_at&workorder=${this.work_order_id}`
                try {
                    const res = await fetchDocuments(query)
                    this.items = res.results || []
                } catch (err) {
                    notifications.showError('Error cargando documentos Simple Factura')
                } finally {
                    this.loading = false
                }
            }
        }
    },
    mounted() {
        this.fetch()
    },
    watch: {
        work_order_id: { handler: 'fetch' },
        documents: { handler: 'fetch', deep: true },
    }
}
</script>
